const normalizeName = (value) => {
  if (typeof value !== "string") return null
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

const normalizeList = (value) => {
  if (!Array.isArray(value)) return []
  const seen = new Set()
  const out = []
  value.forEach((item) => {
    const name = normalizeName(item)
    if (!name || seen.has(name)) return
    seen.add(name)
    out.push(name)
  })
  return out
}

const resolveCantidad = (cantidad, primerVendedorBom, vendedoresBomNombres) => {
  const cantidadNum = Number(cantidad)
  if (Number.isFinite(cantidadNum) && cantidadNum >= 0) return Math.trunc(cantidadNum)
  if (vendedoresBomNombres.length > 0) return vendedoresBomNombres.length
  if (primerVendedorBom) return 1
  return 0
}

export const hasVendedoresBomData = (row) => {
  if (!row || typeof row !== "object") return false
  if (Object.prototype.hasOwnProperty.call(row, "cantidadVendedoresBom")) return true
  if (Object.prototype.hasOwnProperty.call(row, "primerVendedorBom")) return true
  if (Array.isArray(row.vendedoresBomNombres)) return true
  return false
}

export const mergeVendedoresFromFin = (row = {}, fin = {}) => {
  const lista = normalizeList(fin?.vendedoresBomNombres)
  const primer = normalizeName(fin?.primerVendedorBom)
  const cantidad = resolveCantidad(fin?.cantidadVendedores, primer, lista)

  let primerNormalizado = null
  if (cantidad === 1) {
    primerNormalizado = primer || lista[0] || null
  }

  let listaNormalizada = []
  if (cantidad > 1) {
    listaNormalizada = lista
  } else if (cantidad === 1 && primerNormalizado) {
    listaNormalizada = [primerNormalizado]
  }

  return {
    ...row,
    cantidadVendedoresBom: cantidad,
    primerVendedorBom: primerNormalizado,
    vendedoresBomNombres: listaNormalizada,
  }
}

export const getVendedoresTexto = (row) => {
  const primer = normalizeName(row?.primerVendedorBom)
  const lista = normalizeList(row?.vendedoresBomNombres)
  const cantidad = resolveCantidad(row?.cantidadVendedoresBom, primer, lista)

  if (cantidad <= 0) return "-"
  if (cantidad === 1) return primer || lista[0] || "-"
  if (lista.length > 0) return lista.join(", ")
  return primer || "-"
}
